import { createStateSelectorHook } from 'src/lib/sweetState';

import { UiStore } from './UiStore';

export const useNavbarDimensions = createStateSelectorHook(UiStore, [
  'appbarHeight',
  'fullNavbarHeight',
  'notificationsHeight',
  'bannerHeight',
]);
